import { render } from "./Parallax.vue?vue&type=template&id=5bdcff9f"
import script from "./Parallax.vue?vue&type=script&async=true&lang=js"
export * from "./Parallax.vue?vue&type=script&async=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__